var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('div',{staticClass:"header-l"},[(_vm.$route.matched[0]&&_vm.$route.matched[0].path=='/im'&&_vm.$route.params.id)?_c('router-link',{attrs:{"to":{
        path: '/im',
        hash: ("#" + (_vm.$route.params.id)),
        query: _vm.$route.query
      }}},[_c('img',{attrs:{"src":require("@/assets/btn-back.svg"),"alt":"Back"}})]):_vm._e(),(
        _vm.$route.matched[0] && (
        _vm.$route.matched[0].path=='/db' ||
        _vm.$route.matched[0].path=='/os'
      ))?_c('router-link',{attrs:{"to":{
        hash: _vm.$route.hash,
        query: Object.assign({}, _vm.$route.query,
          {hide: _vm.reverse(this.$route.query.hide)})
      }}},[_c('img',{attrs:{"src":require("@/assets/btn-list.svg"),"alt":"List"}})]):_vm._e(),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$route.name))])],1),_c('div',{staticClass:"header-r"},[_c('Options',{attrs:{"title":_vm.$t('header.language'),"items":[{
        id: 'header.language.en',
        title: 'English',
        onclick: function (){ return _vm.setLocale('en'); }
      }, {
        id: 'header.language.ja',
        title: '日本語',
        onclick: function (){ return _vm.setLocale('ja'); }
      }, {
        id: 'header.language.zh',
        title: '中文<國際>',
        onclick: function (){ return _vm.setLocale('zh'); }
      }, {
        id: 'header.language.ko',
        title: '한국',
        onclick: function (){ return _vm.setLocale('ko'); }
      }, {
        id: 'header.language.zh-TW',
        title: '中文<繁體>',
        onclick: function (){ return _vm.setLocale('zh-TW'); }
      }, {
        id: 'header.language.zh-CN',
        title: '中文<简体>',
        onclick: function (){ return _vm.setLocale('zh-CN'); }
      }]}}),(_vm.$route.matched[0]&&_vm.$route.matched[0].path=='/os')?_c('Options',{attrs:{"title":_vm.$t('header.display.title'),"items":[{
        id: 'header.display.character',
        title: _vm.$t('header.display.character'),
        onclick: function (){
          if (this$1.$route.query.view != 'character') { this$1.$router.push({
            hash: this$1.$route.hash,
            query: Object.assign({}, this$1.$route.query,
              {view: 'character'})
          }) }
        }
      }, {
        id: 'header.display.timeline',
        title: _vm.$t('header.display.timeline'),
        onclick: function (){
          if (this$1.$route.query.view != 'timeline') { this$1.$router.push({
            hash: this$1.$route.hash,
            query: Object.assign({}, this$1.$route.query,
              {view: 'timeline'})
          }) }
        }
      }]}}):_vm._e(),(
        _vm.$route.matched[0] && (
        _vm.$route.matched[0].path=='/db' ||
        _vm.$route.matched[0].path=='/os' ||
        _vm.$route.matched[0].path=='/im'
      ))?_c('Options',{attrs:{"title":_vm.$t('header.version'),"items":_vm.versions}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }